import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSplitIconSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32.002}
    height={18.001}
    data-name="Group 52"
    {...props}
  >
    <g data-name="White Box">
      <path fill="#fff" d="M31.501 17.501h-31v-17h31Z" data-name="Path 1" />
      <path fill="#024" d="M1 1v16h30V1zM0 0h32v18H0Z" data-name="Path 2" />
    </g>
    <path fill="#024" d="M1.999 1.999h21.092v14H1.999Z" data-name="Grey Box" />
    <g data-name="Group 153">
      <path fill="#024" d="M24 6.999h6v4h-6Z" data-name="Grey Box-2" />
    </g>
  </svg>
);
export default SvgSplitIconSmall;
